import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireCoachAuth } from "~/lib/coach-middleware";
import { OfferForm, getOfferData } from "~/components/forms/offer-form";
import { useCoachPrivateProfileRequired } from "~/contexts/coach";

export const getCoachOffer = createServerFn({ method: "GET" })
  .middleware([requireCoachAuth])
  .validator(z.object({ coachId: z.string().optional() }))
  .handler(async ({ data, context }) => {
    const coachId = data.coachId ?? context.coach.id;

    if (!coachId) {
      throw new Error("Coach ID is required");
    }

    return await getOfferData({ data: { coachId } });
  });

export const Route = createFileRoute("/coach/_backend/edit-profile/offer/")({
  head: () => ({
    meta: [
      { title: "Edit Main Coaching Offer – Dream Coach Match" },
      { name: "description", content: "Edit your main coaching offer details" },
    ],
  }),
  loader: async () => {
    const offerData = await getCoachOffer({ data: {} });

    return { offerData };
  },
  component: CoachOfferEditPage,
});

function CoachOfferEditPage() {
  useCoachPrivateProfileRequired();
  const { offerData } = Route.useLoaderData();

  return (
    <div>
      <OfferForm initialData={offerData} title="Main Coaching Offer" />
    </div>
  );
}
